import * as constants from '../constant';
import { setEmpreendimentoLancamento } from '../constant';
import LocalStorage from './LocalStorage';

const AuthStorage = {
  is: NIVEL => {
    return constants.HIE_NIVEL[LocalStorage.get(constants.HN)] === NIVEL;
  },
  setUser: user => {
    LocalStorage.set(constants.AUTH_KEY, user.access_token);
    LocalStorage.set(constants.HN, user.hn);
    LocalStorage.set(constants.USER, user);
    LocalStorage.set(constants.ATENDENTE_LANCAMENTO, user.atendente_lancamento);
    LocalStorage.set(constants.CORRETOR_DESLIGADO, user.corretor_desligado === true || user.corretor_desligado === 'true');
    if (user.empreendimento_lancamento) {
      setEmpreendimentoLancamento(user.empreendimento_lancamento);
    }
  },
  setCaracteristicas: caracteristicas => {
    LocalStorage.set(constants.CARACTERISTICAS, caracteristicas);
  },
  getLevelLogged: () => {
    return constants.HIE_NIVEL[AuthStorage.getUser().hn];
  },
  isADM: () => AuthStorage.is(constants.NIVELADM),
  // W-0753 (ADR-001) — perfil administrativo via claim is_adm do JWT
  // (distinto do NIVELADM hierárquico — leitor é "administrativo da empresa",
  // não nível ADM da hierarquia comercial).
  isAdm: () => {
    const user = AuthStorage.getUser();
    if (!user) return false;
    return user.is_adm === true || user.is_adm === 'true';
  },
  isGerente: () => AuthStorage.is(constants.NIVELGER),
  isCorretor: () => AuthStorage.is(constants.NIVELCOR),
  isCAV: () => AuthStorage.is(constants.NIVELCAV),
  isUsuarioTeste: () => {
    const usuario = AuthStorage.getUser();
    if (!usuario) return false;
    return [55, 1418, 901].includes(usuario.usuario);
  },
  getUser: () => {
    return LocalStorage.get(constants.USER);
  },
  getCaracteristicas: () => {
    return LocalStorage.get(constants.CARACTERISTICAS) || [];
  },
  temCaracteristica: codigo => {
    return AuthStorage.getCaracteristicas().includes(codigo);
  },
  temCaracteristicas: (permitidos, rejeitados = []) => {
    const caracteristicas = AuthStorage.getCaracteristicas();
    if (caracteristicas.some(r => rejeitados.includes(r))) return false;
    return (
      permitidos.length === 0 ||
      caracteristicas.some(r => permitidos.includes(r))
    );
  },
  temCaracteristicaGerParametros: exceto => {
    return AuthStorage.temCaracteristicas([347, 279, 295], exceto);
  },
  temCaracteristicaParametrosRenegociacao: () => {
    return AuthStorage.temCaracteristica(600);
  },
  temCaracteristicaGerContratoDigital: exceto => {
    return AuthStorage.temCaracteristicas([513, 514, 515], exceto);
  },
  getCodigoGrupo: () => {
    const user = AuthStorage.getUser();
    return user ? (user.codigo_grupo || 0) : 0;
  },
  isGrupoTI: () => {
    return AuthStorage.getCodigoGrupo() === 2;
  },
  isLogged() {
    return LocalStorage.get(constants.AUTH_KEY);
  },
  removeToken: () => {
    LocalStorage.remove(constants.AUTH_KEY);
    LocalStorage.remove(constants.HN);
    LocalStorage.remove(constants.USER);
    LocalStorage.remove(constants.CORRETOR_DESLIGADO);
    AuthStorage.clearMesaSessao();
    AuthStorage.clearAtendimentoAtivo();
  },
  isIframe: () => {
    return AuthStorage.isLogged() && AuthStorage.getUser().isIframe;
  },
  getEnv: () => {
    const user = AuthStorage.getUser();
    return user ? user.env : null;
  },
  isCorretorDesligado: () => {
    return LocalStorage.get(constants.CORRETOR_DESLIGADO) === true;
  },
  isSenhaPadrao: () => {
    const user = AuthStorage.getUser();
    return !!user && user.senha_padrao === true;
  },
  isSenhaExpirada: () => {
    const user = AuthStorage.getUser();
    return !!user && user.senha_expirada === true;
  },
  precisaTrocarSenha: () => {
    return AuthStorage.isSenhaPadrao() || AuthStorage.isSenhaExpirada();
  },
  isAtendenteLancamento: () => {
    const user = AuthStorage.getUser();
    return user && user.atendente_lancamento;
  },

  // Controle de Mesa por Sessão
  setMesaSessao: mesa => {
    LocalStorage.set(constants.MESA_ATENDIMENTO_SESSAO, {
      numeroMesa: mesa.numeroMesa,
      codigoMesa: mesa.codigoMesa,
      timestamp: new Date().getTime(),
    });
  },
  getMesaSessao: () => {
    const mesaData = LocalStorage.get(constants.MESA_ATENDIMENTO_SESSAO);
    return mesaData || null;
  },
  clearMesaSessao: () => {
    LocalStorage.remove(constants.MESA_ATENDIMENTO_SESSAO);
  },
  temMesaSessao: () => {
    const mesa = LocalStorage.get(constants.MESA_ATENDIMENTO_SESSAO);
    return mesa && mesa.numeroMesa ? true : false;
  },

  // Controle de Atendimento Ativo
  setAtendimentoAtivo: (codigoAtendimento) => {
    LocalStorage.set(constants.ATENDIMENTO_ATIVO, codigoAtendimento);
  },
  getAtendimentoAtivo: () => {
    return LocalStorage.get(constants.ATENDIMENTO_ATIVO);
  },
  clearAtendimentoAtivo: () => {
    LocalStorage.remove(constants.ATENDIMENTO_ATIVO);
  },
  temAtendimentoAtivo: () => {
    const codigo = LocalStorage.get(constants.ATENDIMENTO_ATIVO);
    return codigo ? true : false;
  },
};

export default AuthStorage;
